<template>
    <div class="send-question-box">
        <!-- <div class="send-back">
            <a-button @click="toBack">返回</a-button>
        </div> -->
        <div class="send-form-wrapper">
            <div class="send-form-box">
                <div class="send-form-title">开放平台问题反馈</div>
                <div class="notice">
                    <span>平台受理文档错漏问题，不受理如何开发、如何解决诸如此类问题</span>
                </div>
                <div class="send-form-content">
                    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" :layout="formLayout" @submit="handleSubmit">
                        <a-form-item label="问题描述">
                            <a-textarea
                                v-decorator="['description', { rules: [{ required: true, message: '请输入问题描述' }] }]"
                            />
                        </a-form-item>
                        <a-form-item label="改进意见">
                            <a-textarea
                                v-decorator="['suggestions', { rules: [{ required: true, message: '请输入改进意见' }] }]"
                            />
                        </a-form-item>
                        <a-form-item label="文档链接">
                            <a-textarea
                                v-decorator="['docLink', { rules: [{ required: true, message: '请输入文档链接' }], initialValue: defaultLink }]"
                            />
                        </a-form-item>
                        <a-form-item label="联系信息">
                            <a-input
                                v-decorator="['contactInfo', { rules: [{ required: true, message: '请输入文档联系信息' }] }]"
                            />
                        </a-form-item>
                        <a-form-item :wrapper-col="{ span: 24 }" style="text-align: center;">
                            <a-button type="primary" html-type="submit">
                                提交
                            </a-button>
                        </a-form-item>
                    </a-form>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import { getCookie } from '@/utils/common';
import axios from 'axios';

export default {
 name: 'sendQuestion',
 components: {},
 props: {},
 data() {
   return {
    formLayout: 'vertical',
    defaultLink: ""
  };
 },
 watch: {},
 computed: {},
 beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'sendForm' })
 },
 created() {
    if(this.$route.query && this.$route.query.link){
        this.defaultLink = decodeURIComponent(this.$route.query.link);
    }
 },
 mounted() {},
 methods: {
    handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
            console.log('err--->', err)
            console.log('values--->', values)
            let params = {...values};
            const loginKey = getCookie('loginKey');
            // 校验成功
            if (!err) {
                const url = '/faq/problemFeedback/save'
                axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                axios.defaults.headers.token = loginKey;
                axios.post(url, params).then((res) => {
                    console.log('res', res)
                    if (!res) return;
                    if (res.data.code == 0) {
                        this.$message.success({ content: '反馈成功。' })
                        this.$router.go(-1)
                    } else {
                        this.$message.warning({ content: res.data.msg })
                    }
                    
                })
            }
        });
    },
    toBack() {
        this.$router.go(-1)
    }
 },
};
</script>
<style scoped lang="scss">
.send-question-box {
    width: 100%;
    height: 100%;
    background-color: #f6f6f6;
    .send-back {
        width: 100%;
        height: 40px;
        padding-left: 45px;
        padding-top: 20px;
    }
    .send-form-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .send-form-box {
        width: 800px;
        background: #fff;
        .send-form-title {
            font-size: 30px;
            font-weight: bold;
            text-align: center;
            background: #1890ff;
            color: #fff;
            padding: 10px 0;
        }

        .send-form-content {
            padding: 20px;
        }
    }  
}
.notice{
    text-align: center;
    color: red;
    font-size: 14px;
}
</style>